import React, { useEffect, useContext } from 'react';
import './InlinePhoto.scss';
import { WidthContext } from '../../WidthContext';
import { photoContents } from './photoContents';

function InlinePhoto({ index, photoRef }) {
  const width = useContext(WidthContext);
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            photoRef.current.style.transform = 'scale(1)';
          }
        });
      },
      { threshold: [0, 0.3] }
    );
    observer.observe(photoRef.current);
  }, [photoRef]);

  return (
    <section className="inline">
      <img
        className="inline__image"
        src={width > 480 ? photoContents[index].desktop : photoContents[index].mobile}
        alt=""
        ref={photoRef}
      />
    </section>
  );
}

export default InlinePhoto;
